import React, { useState } from 'react';
import './HelpGuide.css';

const GUIDE_STEPS = [
  {
    title: 'Velkommen til FastTrack',
    content: 'FastTrack er din kundeportal hos Ole Larsen Transport. Her kan du oprette og administrere bookinger, printe fragtbreve og pallelabels, og holde styr på dine leverancer.',
    icon: '🚛',
  },
  {
    title: 'Overblik',
    content: 'Din startside viser aktive og tidligere ordrer. Brug "Widgets" knappen til at vælge hvilke sektioner du vil se. Klik "Ret" for at redigere en booking direkte.',
    icon: '📋',
  },
  {
    title: 'Opret booking',
    content: 'Klik "Book ordre" for at oprette en ny booking. Vælg afsender og modtager — AI-forslag vises automatisk baseret på din historik. Udfyld varelinjer med antal, enhed og emballage.',
    icon: '📦',
  },
  {
    title: 'Emballage og retur',
    content: 'Under hver varelinje angiver du EU, ½ og ¼ paller der leveres. Brug de orange "Retur"-felter til emballagebytte — paller du tager med retur fra modtager. Alt vises korrekt på fragtbrevet.',
    icon: '♻️',
  },
  {
    title: 'Import fra Excel',
    content: 'Klik "Import" for at uploade en Excel-fil med flere bookinger. Download skabelonen, udfyld den, og upload. Systemet matcher automatisk adresser fra dit register.',
    icon: '📁',
  },
  {
    title: 'Alle ordrer',
    content: 'Se alle bookinger med filtre på hver kolonne. Eksporter filtrerede resultater til Excel. Brug checkboxes til at vælge flere bookinger og batch-print pallelabels eller fragtbreve.',
    icon: '🔍',
  },
  {
    title: 'Kommentarer',
    content: 'Klik "Kommentar" på en booking i Alle ordrer for at skrive en besked til Ole Larsen Transport. I kan skrive frem og tilbage direkte på bookingen — fx "Levering flyttet til bagindgang".',
    icon: '💬',
  },
  {
    title: 'Fragtbreve og pallelabels',
    content: 'Fragtbrevet viser alle varelinjer med emballage og retur-kvittering. Pallelabels genererer en side per palle med "Palle X af Y". Brug bulk-print i Alle ordrer for at printe flere på en gang.',
    icon: '🖨️',
  },
  {
    title: 'Rediger bookinger',
    content: 'Klik "Ret" eller "Rediger" på en booking for at ændre den. Ændringer sendes til godkendelse igen. Låste bookinger (allerede faktureret) kan ikke redigeres. Er en booking afvist, kan du se begrundelsen og rette den.',
    icon: '✏️',
  },
  {
    title: 'Kalender',
    content: 'Under "Kalender" fanen ser du dine bookinger i et månedsoverblik. Grønne badges viser antal bookinger per dag. Klik på en dag for at se detaljer.',
    icon: '📅',
  },
  {
    title: 'AI Assistent',
    content: 'Klik den gule AI-knap nederst til højre. Assistenten kan: søge i bookinger ("vis bookinger til Arla"), oprette bookinger ("book 20 paller til Vejle i morgen"), vise adresser og oprette brugere.',
    icon: '🤖',
  },
  {
    title: 'Indsigt',
    content: 'Under "Indsigt" fanen ser du statistik for de seneste 30 dage: antal bookinger, trend, top-ruter, top-varer og ugentlig fordeling.',
    icon: '📊',
  },
  {
    title: 'Email-notifikationer',
    content: 'Du modtager automatisk en email når en booking godkendes eller afvises. Afviste bookinger inkluderer begrundelsen, så du hurtigt kan rette og sende igen.',
    icon: '📧',
  },
  {
    title: 'Dashboard-widgets',
    content: 'Klik "Widgets" i Overblik for at tilpasse dit dashboard. Du kan slå aktive ordrer, tidligere ordrer og sidebaren til/fra. Dine valg huskes.',
    icon: '🧩',
  },
  {
    title: 'Genvejstaster',
    content: 'Klik "Genveje" eller tryk Alt+K for oversigten. Hurtige genveje: Alt+O (Overblik), Alt+N (Ny booking), Alt+A (Alle ordrer), Alt+C (AI chat), Alt+S (Søg).',
    icon: '⌨️',
  },
  {
    title: 'Brugerroller',
    content: 'Admin: fuld adgang inkl. brugerstyring. Bruger: kan oprette og redigere bookinger. Visning: kan kun se — ingen oprettelse. Administrer brugere under "Administration".',
    icon: '👥',
  },
];

function HelpGuide({ onClose }) {
  const [step, setStep] = useState(0);

  const current = GUIDE_STEPS[step];
  const isLast = step === GUIDE_STEPS.length - 1;
  const isFirst = step === 0;

  return (
    <div className="help-overlay" onClick={onClose}>
      <div className="help-modal" onClick={(e) => e.stopPropagation()}>
        <button className="help-close" onClick={onClose}>&#10005;</button>

        <div className="help-step-indicator">
          {GUIDE_STEPS.map((_, i) => (
            <div
              key={i}
              className={`help-dot ${i === step ? 'active' : ''} ${i < step ? 'done' : ''}`}
              onClick={() => setStep(i)}
            />
          ))}
        </div>

        <div className="help-content">
          <div className="help-icon">{current.icon}</div>
          <h2 className="help-title">{current.title}</h2>
          <p className="help-text">{current.content}</p>
        </div>

        <div className="help-actions">
          {!isFirst && (
            <button className="help-btn help-btn-secondary" onClick={() => setStep(step - 1)}>
              Tilbage
            </button>
          )}
          <div className="help-step-count">{step + 1} / {GUIDE_STEPS.length}</div>
          {isLast ? (
            <button className="help-btn help-btn-primary" onClick={onClose}>
              Kom i gang!
            </button>
          ) : (
            <button className="help-btn help-btn-primary" onClick={() => setStep(step + 1)}>
              Næste
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default HelpGuide;
